import { render, staticRenderFns } from "./invoiceAdminInpt.vue?vue&type=template&id=3ecfe128&scoped=true"
import script from "./invoiceAdminInpt.vue?vue&type=script&lang=js"
export * from "./invoiceAdminInpt.vue?vue&type=script&lang=js"
import style0 from "./invoiceAdminInpt.vue?vue&type=style&index=0&id=3ecfe128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecfe128",
  null
  
)

export default component.exports